export enum MitigationStatusEnum {
  Ongoing = 'ongoing',
  SelfVerified = 'self-verified'
}
